import axios from "axios";
import { useEffect, useState } from "react";
import {
  defaultFilteringForEvent,
  getDateFiltering,
} from "../common/EntitiesManagement";
import localize from "../common/localize";
import GeneralStatistics from "../components/generalStadistics/GeneralStadistics";
import useGlobalContext from "../hooks/useGlobalContext";
import LoadingPanel from "../components/common/LoadingPanel";
import { Alert, Box, Button, TextField, Typography } from "@mui/material";
import ModalBackground from "../components/common/ModalBackground";
import {
  LocalizationProvider,
  DatePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  getInputLabelProps,
  getInputProps,
  PopperFullWidth,
} from "../common/appStyles";

export default function Home() {
  const { EVENTS_API, config, userManagementId } = useGlobalContext();
  const [isLoading, setIsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState({});
  const [paymentData, setPaymentData] = useState([]);
  const [filteringDates, setFilteringDates] = useState(
    defaultFilteringForEvent(true)
  );
  const [showMonthModal, setShowMonthModal] = useState(false);
  const [filterDate, setFilterDate] = useState(new Date());

  const requestHeadersData = {
    ...config,
    headers: {
      ...config.headers,
      ManagementId: userManagementId,
      Filter: JSON.stringify(filteringDates),
    },
  };

  const getEventsPayment = async () => {
    const { data } = await axios.get(
      `${EVENTS_API}/paymentResume`,
      requestHeadersData
    );

    if (data?.Data && data.Data.length > 0) {
      setPaymentData(data.Data);
    }
  };

  const getDashboardStatistics = async () => {
    setIsLoading(true);

    const { data } = await axios.get(
      `${EVENTS_API}/statistics`,
      requestHeadersData
    );
    if (!data) {
      await getEventsPayment();
      setIsLoading(false);
      return;
    }

    setDashboardData(data.Data);
    await getEventsPayment();
    setIsLoading(false);
  };

  const showMonthCalendar = () => {
    setShowMonthModal(true);
  };

  useEffect(() => {
    if (config && filteringDates) {
      getDashboardStatistics();
    }
  }, [filteringDates]);

  return (
    <div style={{ padding: "16px" }}>
      {isLoading ? (
        <LoadingPanel />
      ) : (
        <div>
          {showMonthModal && (
            <ModalBackground
              isDrawerMode
              okButtonText={localize.accept}
              onClickToCancel={() => {
                setShowMonthModal(false);
              }}
              onClickToSubmit={() => {
                setFilteringDates(getDateFiltering(new Date(filterDate)));
                setShowMonthModal(false);
              }}
              okButtonAlwaysAvailable
              title={localize.select_month}
              showModal={showMonthModal}
              setShowModal={setShowMonthModal}
              Component={
                <Box
                  className="w-full flex flex-col mt-2 gap-4"
                  style={{ width: "100%" }}
                >
                  <Alert severity="info" className="w-full">
                    <label className="text-xs">
                      {localize.info_month_change_home}
                    </label>
                  </Alert>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      views={["year", "month"]}
                      label={`${localize.month}`}
                      className="w-full"
                      InputLabelProps={getInputLabelProps()}
                      inputProps={getInputProps()}
                      PopperComponent={PopperFullWidth}
                      maxDate={new Date()}
                      value={filterDate}
                      onChange={(value) => {
                        setFilterDate(value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "",
                          }}
                          InputLabelProps={{
                            ...params.InputLabelProps,
                            style: { fontSize: "1em", paddingBottom: "10px" },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Box>
              }
            />
          )}
          <Alert severity="info">
            <Box className="flex gap-1 items-center flex-wrap">
              {localize.dashboard_description}

              <Button
                variant="text"
                onClick={showMonthCalendar}
                sx={{ fontSize: "0.9em", cursor: "pointer", padding: "0px" }}
              >
                {filteringDates[0].Value}
              </Button>
            </Box>
          </Alert>

          <GeneralStatistics
            eventsByOperationalStatus={dashboardData?.EventsByOperationalStatus}
            eventsByStatus={dashboardData?.EventsByStatus}
            eventsDistributionOnPersonal={
              dashboardData?.EventsDistributionOnPersonal
            }
            eventsByState={dashboardData?.EventsByState}
            eventsByCity={dashboardData?.EventsByCity}
            eventsByType={dashboardData?.EventsByType}
            eventsPayment={paymentData}
            eventsByProceeding={dashboardData?.EventsByProceeding}
            initialDate={filteringDates[0].FilterValue.Value}
            finalDate={filteringDates[0].FilterValue.AlternateValue}
          />
        </div>
      )}
    </div>
  );
}
